import ParasutSettings from "../components/ParasutSettings";
import CopyLog from "../components/CopyLog";
import AtfSettings from "../components/AtfSettings";
import ReleasesSettings from "../components/ReleasesSettings";
import AiSettings from "../components/AiSettings";
import DeleteAllCustomers from "../components/DeleteAllCustomers";
import { NAV } from "../components/Layout";
import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Switch } from "../components/ui/switch";
import ConfirmDialog from "../components/ConfirmDialog";
import ColorPicker from "../components/ColorPicker";
import MenuSettings from "../components/MenuSettings";
import RowSizeSettings from "../components/RowSizeSettings";
import BrandSettings from "../components/BrandSettings";
import PaymentSettings from "../components/PaymentSettings";
import { trUpper } from "../lib/mw";
import { toast } from "sonner";
import {
  Columns3, Users as UsersIcon, ArrowUp, ArrowDown, Trash2, Plus, X, Save, GripVertical,
  KeyRound, ScrollText, Pencil, Plug, ArrowRightLeft, CheckCircle2, XCircle, ShieldCheck, MessageCircle, Menu as MenuIcon,
} from "lucide-react";

const TYPES = [
  { v: "text", l: "DÜZ METİN" }, { v: "number", l: "SAYI" }, { v: "currency", l: "PARA (₺)" },
  { v: "date", l: "TARİH" }, { v: "email", l: "EMAIL" }, { v: "select", l: "SEÇENEK LİSTESİ" },
  { v: "province", l: "İL" }, { v: "district", l: "İLÇE" },
];

function ColumnsManager() {
  const { columns, loadColumns } = useAuth();
  const [cols, setCols] = useState([]);
  const [openOpt, setOpenOpt] = useState({});
  const [newOpt, setNewOpt] = useState({});
  useEffect(() => { setCols(JSON.parse(JSON.stringify(columns))); }, [columns]);
  const update = (i, patch) => setCols((c) => c.map((x, idx) => (idx === i ? { ...x, ...patch } : x)));
  const move = (i, dir) => { const j = i + dir; if (j < 0 || j >= cols.length) return; const c = [...cols]; [c[i], c[j]] = [c[j], c[i]]; setCols(c); };
  const addCol = () => setCols((c) => [...c, { key: "ozel_" + Date.now(), label: "YENİ KOLON", type: "text", visible: true, order: c.length + 1 }]);
  const removeCol = (i) => setCols((c) => c.filter((_, idx) => idx !== i));
  const addOption = (i) => { const val = trUpper((newOpt[i] || "").trim()); if (!val) return; update(i, { options: [...(cols[i].options || []), val] }); setNewOpt((o) => ({ ...o, [i]: "" })); };
  const removeOption = (i, opt) => update(i, { options: cols[i].options.filter((o) => o !== opt) });
  const setColor = (i, opt, color) => update(i, { colors: { ...(cols[i].colors || {}), [opt]: color } });
  const save = async () => { cols.forEach((c, idx) => (c.order = idx + 1)); await api.put("/settings/columns", { data: { columns: cols } }); await loadColumns(); toast.success("KOLONLAR KAYDEDİLDİ"); };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <p className="text-sm text-slate-400">SATIR BAŞLIKLARINI DÜZENLEYİN, YENİ EKLEYİN VEYA SIRALAYIN</p>
        <div className="flex gap-2">
          <Button data-testid="add-column-button" variant="outline" onClick={addCol} className="border-slate-700 bg-slate-800 text-slate-200"><Plus className="mr-1 h-4 w-4" /> KOLON EKLE</Button>
          <Button data-testid="save-columns-button" onClick={save} className="bg-blue-600 text-white hover:bg-blue-700"><Save className="mr-1 h-4 w-4" /> KAYDET</Button>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-1.5 xl:grid-cols-2">
        {cols.map((c, i) => (
          <div key={c.key} className="rounded-lg border border-slate-800 bg-slate-900 px-2 py-1.5">
            <div className="flex flex-wrap items-center gap-2">
              <GripVertical className="h-4 w-4 text-slate-600" />
              <Input data-testid={`col-label-${i}`} value={c.label} onChange={(e) => update(i, { label: trUpper(e.target.value) })} className="h-8 w-44 border-slate-700 bg-slate-800 text-xs text-slate-100" />
              <select value={c.type} onChange={(e) => update(i, { type: e.target.value })} className="h-8 rounded-md border border-slate-700 bg-slate-800 px-2 text-xs text-slate-100">
                {TYPES.map((t) => <option key={t.v} value={t.v}>{t.l}</option>)}
              </select>
              <div className="flex items-center gap-2"><Switch checked={c.visible} onCheckedChange={(v) => update(i, { visible: v })} /><span className="text-xs text-slate-400">GÖSTER</span></div>
              {c.type === "select" && <button data-testid={`col-options-toggle-${i}`} onClick={() => setOpenOpt((o) => ({ ...o, [i]: !o[i] }))} className={`rounded px-2 py-1 text-[10px] font-bold ${openOpt[i] ? "bg-blue-600 text-white" : "bg-slate-800 text-slate-300"}`}>SEÇENEKLER ({(c.options || []).length})</button>}
              <div className="ml-auto flex gap-1">
                <button onClick={() => move(i, -1)} className="rounded p-1.5 text-slate-400 hover:bg-slate-700"><ArrowUp className="h-4 w-4" /></button>
                <button onClick={() => move(i, 1)} className="rounded p-1.5 text-slate-400 hover:bg-slate-700"><ArrowDown className="h-4 w-4" /></button>
                <button onClick={() => removeCol(i)} className="rounded p-1.5 text-slate-400 hover:bg-slate-700 hover:text-rose-400"><Trash2 className="h-4 w-4" /></button>
              </div>
            </div>
            {c.type === "select" && openOpt[i] && (
              <div className="mt-1.5 flex flex-wrap items-center gap-1.5 border-t border-slate-800 pt-1.5">
                {(c.options || []).map((o) => {
                  const clr = (c.colors || {})[o];
                  return (
                    <span key={o} className="flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold" style={clr ? { background: `${clr}22`, color: clr } : { background: "#1e293b", color: "#e2e8f0" }}>
                      <ColorPicker value={clr} onChange={(color) => setColor(i, o, color)} />{o}
                      <button onClick={() => removeOption(i, o)} className="opacity-60 hover:text-rose-400 hover:opacity-100"><X className="h-3 w-3" /></button>
                    </span>
                  );
                })}
                <div className="flex items-center gap-1">
                  <Input data-testid={`col-new-option-${i}`} value={newOpt[i] || ""} onChange={(e) => setNewOpt((o) => ({ ...o, [i]: e.target.value }))} onKeyDown={(e) => e.key === "Enter" && addOption(i)} placeholder="YENİ SEÇENEK" className="h-8 w-40 border-slate-700 bg-slate-800 text-xs text-slate-100" />
                  <button onClick={() => addOption(i)} className="rounded bg-blue-600 p-1.5 text-white hover:bg-blue-700"><Plus className="h-3.5 w-3.5" /></button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

function UsersManager() {
  const { columns, isSuperAdmin } = useAuth();
  const branchOpts = (columns.find((c) => c.key === "subesi")?.options) || [];
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ username: "", password: "", name: "", role: "user", subeler: [] });
  const [confirm, setConfirm] = useState(null);
  const [editing, setEditing] = useState(null);

  const load = () => api.get("/users").then((r) => setUsers(r.data));
  useEffect(() => { load(); }, []);

  const toggleBranch = (setter, list, b) => setter(list.includes(b) ? list.filter((x) => x !== b) : [...list, b]);

  const add = async () => {
    if (!form.username || !form.password) { toast.error("KULLANICI ADI VE ŞİFRE GEREKLİ"); return; }
    try { await api.post("/users", form); toast.success("KULLANICI EKLENDİ"); setForm({ username: "", password: "", name: "", role: "user", subeler: [] }); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "HATA"); }
  };
  const saveEdit = async () => {
    try { await api.put(`/users/${editing.id}`, { name: editing.name, role: editing.role, subeler: editing.subeler || [], komisyon: !!editing.komisyon, password: editing.password || undefined }); toast.success("GÜNCELLENDİ"); setEditing(null); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "HATA"); }
  };
  const del = async () => { await api.delete(`/users/${confirm}`); toast.success("SİLİNDİ"); setConfirm(null); load(); };

  return (
    <div className="space-y-4">
      <div className="rounded-lg border border-slate-800 bg-slate-900 p-4 space-y-3">
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-4">
          <Input data-testid="user-username" placeholder="KULLANICI ADI" value={form.username} onChange={(e) => setForm((f) => ({ ...f, username: e.target.value }))} className="h-10 border-slate-700 bg-slate-800 text-slate-100" />
          <Input data-testid="user-name" placeholder="AD SOYAD" value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: trUpper(e.target.value) }))} className="h-10 border-slate-700 bg-slate-800 text-slate-100" />
          <Input data-testid="user-password" type="password" placeholder="ŞİFRE" value={form.password} onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))} className="h-10 border-slate-700 bg-slate-800 text-slate-100" />
          <select data-testid="user-role" value={form.role} onChange={(e) => setForm((f) => ({ ...f, role: e.target.value }))} className="h-10 rounded-md border border-slate-700 bg-slate-800 px-2 text-sm text-slate-100">
            <option value="user">KULLANICI</option>{isSuperAdmin && <option value="admin">YÖNETİCİ</option>}
          </select>
        </div>
        {form.role === "user" && branchOpts.length > 0 && (
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-xs font-semibold text-slate-400">GÖREBİLECEĞİ ŞUBELER (boş = hepsi):</span>
            {branchOpts.map((b) => (
              <label key={b} className="flex cursor-pointer items-center gap-1 rounded-full border border-slate-700 px-2 py-0.5 text-xs text-slate-300">
                <input type="checkbox" checked={form.subeler.includes(b)} onChange={() => setForm((f) => ({ ...f, subeler: f.subeler.includes(b) ? f.subeler.filter((x) => x !== b) : [...f.subeler, b] }))} className="h-3.5 w-3.5 accent-blue-500" />{b}
              </label>
            ))}
          </div>
        )}
        <div className="flex justify-end">
          <Button data-testid="add-user-button" onClick={add} className="bg-blue-600 text-white hover:bg-blue-700"><Plus className="mr-1 h-4 w-4" /> KULLANICI EKLE</Button>
        </div>
      </div>

      <div className="overflow-hidden rounded-lg border border-slate-800 bg-slate-900">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-slate-800 bg-slate-800/50 text-left text-xs uppercase tracking-wider text-slate-400">
              <th className="px-4 py-3">AD</th><th className="px-4 py-3">KULLANICI ADI</th><th className="px-4 py-3">ROL</th><th className="px-4 py-3">ŞUBELER</th><th className="px-4 py-3 text-right">İŞLEM</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-b border-slate-800/60">
                <td className="px-4 py-2.5 text-slate-200">{u.name}</td>
                <td className="px-4 py-2.5 text-slate-400">{u.username || "-"}</td>
                <td className="px-4 py-2.5"><span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${u.role === "admin" ? "bg-amber-500/20 text-amber-300" : "bg-slate-700 text-slate-300"}`}>{u.role === "admin" ? "YÖNETİCİ" : "KULLANICI"}</span></td>
                <td className="px-4 py-2.5 text-xs text-slate-400">{(u.subeler || []).length ? u.subeler.join(", ") : "HEPSİ"}{u.komisyon && <span className="ml-1 rounded bg-amber-600/30 px-1 text-[10px] font-bold text-amber-300">KOMİSYON</span>}</td>
                <td className="px-4 py-2.5 text-right">
                  <button data-testid={`edit-user-${u.id}`} onClick={() => setEditing({ ...u, password: "", subeler: u.subeler || [] })} className="rounded-md p-1.5 text-slate-400 hover:bg-slate-700 hover:text-blue-400"><Pencil className="h-4 w-4" /></button>
                  <button data-testid={`del-user-${u.id}`} onClick={() => setConfirm(u.id)} className="rounded-md p-1.5 text-slate-400 hover:bg-slate-700 hover:text-rose-400"><Trash2 className="h-4 w-4" /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {editing && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4" onClick={() => setEditing(null)}>
          <div className="w-full max-w-md space-y-3 rounded-xl border border-slate-700 bg-slate-900 p-5" onClick={(e) => e.stopPropagation()}>
            <h3 className="font-head text-lg font-bold text-white">KULLANICI DÜZENLE</h3>
            <Input placeholder="AD SOYAD" value={editing.name || ""} onChange={(e) => setEditing((x) => ({ ...x, name: trUpper(e.target.value) }))} className="h-10 border-slate-700 bg-slate-800 text-slate-100" />
            <Input type="password" placeholder="YENİ ŞİFRE (boş=değişmez)" value={editing.password || ""} onChange={(e) => setEditing((x) => ({ ...x, password: e.target.value }))} className="h-10 border-slate-700 bg-slate-800 text-slate-100" />
            <select value={editing.role} onChange={(e) => setEditing((x) => ({ ...x, role: e.target.value }))} className="h-10 w-full rounded-md border border-slate-700 bg-slate-800 px-2 text-sm text-slate-100">
              <option value="user">KULLANICI</option>{isSuperAdmin && <option value="admin">YÖNETİCİ</option>}
            </select>
            {editing.role === "user" && (
              <label className="flex cursor-pointer items-center gap-2 text-xs text-amber-300"><input data-testid="edit-user-komisyon" type="checkbox" checked={!!editing.komisyon} onChange={(e) => setEditing((x) => ({ ...x, komisyon: e.target.checked }))} className="h-3.5 w-3.5 accent-amber-500" /> KOMİSYONLU İŞLERİ GÖREBİLİR</label>
            )}
            {editing.role === "user" && branchOpts.length > 0 && (
              <div className="flex flex-wrap gap-2">
                {branchOpts.map((b) => (
                  <label key={b} className="flex cursor-pointer items-center gap-1 rounded-full border border-slate-700 px-2 py-0.5 text-xs text-slate-300">
                    <input type="checkbox" checked={(editing.subeler || []).includes(b)} onChange={() => setEditing((x) => ({ ...x, subeler: (x.subeler || []).includes(b) ? x.subeler.filter((y) => y !== b) : [...(x.subeler || []), b] }))} className="h-3.5 w-3.5 accent-blue-500" />{b}
                  </label>
                ))}
              </div>
            )}
            <div className="flex justify-end gap-2">
              <Button variant="outline" onClick={() => setEditing(null)} className="border-slate-700 bg-slate-800 text-slate-200">İPTAL</Button>
              <Button data-testid="save-user-edit" onClick={saveEdit} className="bg-blue-600 text-white hover:bg-blue-700">KAYDET</Button>
            </div>
          </div>
        </div>
      )}
      <ConfirmDialog open={!!confirm} onOpenChange={(v) => !v && setConfirm(null)} title="KULLANICI SİLİNSİN Mİ?" onConfirm={del} />
    </div>
  );
}

function SecurityManager() {
  const { tenantInfo, loadTenant } = useAuth();
  const [pin, setPin] = useState("");
  const save = async () => { await api.put("/tenant/pin", { pin }); toast.success(pin ? "PIN AYARLANDI" : "PIN KALDIRILDI"); setPin(""); loadTenant(); };
  return (
    <div className="max-w-lg space-y-4">
      <div className="rounded-lg border border-slate-800 bg-slate-900 p-5 space-y-3">
        <div className="flex items-center gap-2 text-slate-200"><KeyRound className="h-5 w-5 text-amber-400" /><span className="font-semibold">EXCEL / EKRAN İNDİRME PINİ</span></div>
        <p className="text-sm text-slate-400">PIN ayarlanırsa, EXCEL indirme ve cari ana listeyi gizle/göster işlemleri PIN gerektirir. Durum: <b className={tenantInfo.has_pin ? "text-emerald-400" : "text-rose-400"}>{tenantInfo.has_pin ? "PIN TANIMLI" : "PIN YOK"}</b></p>
        <Input data-testid="pin-input" type="password" placeholder="YENİ PIN (boş bırakıp kaydet = kaldır)" value={pin} onChange={(e) => setPin(e.target.value)} className="h-10 border-slate-700 bg-slate-800 text-slate-100" />
        <Button data-testid="save-pin" onClick={save} className="bg-blue-600 text-white hover:bg-blue-700"><Save className="mr-1 h-4 w-4" /> KAYDET</Button>
      </div>
    </div>
  );
}

function AuditManager() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit").then((r) => setLogs(r.data)).catch(() => {}); }, []);
  return (
    <div className="overflow-hidden rounded-lg border border-slate-800 bg-slate-900">
      <table className="w-full text-sm">
        <thead><tr className="border-b border-slate-800 bg-slate-800/50 text-left text-xs uppercase tracking-wider text-slate-400">
          <th className="px-4 py-3">TARİH</th><th className="px-4 py-3">KULLANICI</th><th className="px-4 py-3">İŞLEM</th><th className="px-4 py-3">DETAY</th>
        </tr></thead>
        <tbody>
          {logs.length === 0 && <tr><td colSpan={4} className="px-4 py-10 text-center text-slate-500">KAYIT YOK</td></tr>}
          {logs.map((l) => (
            <tr key={l.id} className="border-b border-slate-800/60">
              <td className="px-4 py-2 font-mono text-xs text-slate-500">{new Date(l.created_at).toLocaleString("tr-TR")}</td>
              <td className="px-4 py-2 text-slate-300">{l.user_name}</td>
              <td className="px-4 py-2"><span className="rounded bg-slate-700 px-2 py-0.5 text-xs font-semibold text-slate-200">{l.action}</span></td>
              <td className="px-4 py-2 text-slate-400">{l.detail}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function IntegrationsManager() {
  const [cfg, setCfg] = useState({ paracut_key: "", twilio_sid: "", twilio_token: "", twilio_from: "" });
  const [status, setStatus] = useState({ has_paracut: false, has_twilio: false });
  const cy = new Date().getFullYear();
  const [yr, setYr] = useState({ from_year: cy, to_year: cy + 1 });
  useEffect(() => {
    api.get("/tenant/integrations").then((r) => {
      setCfg({ paracut_key: r.data.paracut_key || "", twilio_sid: r.data.twilio_sid || "", twilio_token: r.data.twilio_token || "", twilio_from: r.data.twilio_from || "" });
      setStatus({ has_paracut: r.data.has_paracut, has_twilio: r.data.has_twilio });
    }).catch(() => {});
  }, []);
  const save = async () => { const r = await api.put("/tenant/integrations", cfg); setStatus({ has_paracut: r.data.has_paracut, has_twilio: r.data.has_twilio }); toast.success("ENTEGRASYONLAR KAYDEDİLDİ"); };
  const copyYear = async () => { const r = await api.post("/customers/copy-year", { from_year: Number(yr.from_year), to_year: Number(yr.to_year) }); toast.success(`${r.data.copied} MÜŞTERİ ${yr.to_year} YILINA AKTARILDI`); };
  const Badge = ({ on }) => on
    ? <span className="flex items-center gap-1 rounded-full bg-emerald-500/20 px-2 py-0.5 text-xs font-semibold text-emerald-300"><CheckCircle2 className="h-3.5 w-3.5" /> BAĞLI</span>
    : <span className="flex items-center gap-1 rounded-full bg-slate-700 px-2 py-0.5 text-xs font-semibold text-slate-400"><XCircle className="h-3.5 w-3.5" /> BAĞLI DEĞİL</span>;
  return (
    <div className="max-w-2xl space-y-4">
      <div className="rounded-lg border border-slate-800 bg-slate-900 p-5 space-y-3">
        <div className="flex items-center justify-between"><div className="flex items-center gap-2 text-slate-200"><Plug className="h-5 w-5 text-sky-400" /><span className="font-semibold">SMS (TWILIO) — RANDEVU HATIRLATMA</span></div><Badge on={status.has_twilio} /></div>
        <p className="text-sm text-slate-400">Twilio bilgileri girilirse, telefon numarası olan randevular zamanı gelince SMS olarak da gönderilir. Boşsa sadece ekran balonu çalışır.</p>
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
          <Input data-testid="twilio-sid" placeholder="ACCOUNT SID" value={cfg.twilio_sid} onChange={(e) => setCfg((c) => ({ ...c, twilio_sid: e.target.value }))} className="h-10 border-slate-700 bg-slate-800 text-slate-100" />
          <Input data-testid="twilio-token" type="password" placeholder="AUTH TOKEN" value={cfg.twilio_token} onChange={(e) => setCfg((c) => ({ ...c, twilio_token: e.target.value }))} className="h-10 border-slate-700 bg-slate-800 text-slate-100" />
          <Input data-testid="twilio-from" placeholder="GÖNDEREN NO (+90…)" value={cfg.twilio_from} onChange={(e) => setCfg((c) => ({ ...c, twilio_from: e.target.value }))} className="h-10 border-slate-700 bg-slate-800 text-slate-100" />
        </div>
      </div>
      <Button data-testid="save-integrations" onClick={save} className="bg-blue-600 text-white hover:bg-blue-700"><Save className="mr-1 h-4 w-4" /> ENTEGRASYONLARI KAYDET</Button>

      <div className="rounded-lg border border-slate-800 bg-slate-900 p-5 space-y-3">
        <div className="flex items-center gap-2 text-slate-200"><ArrowRightLeft className="h-5 w-5 text-emerald-400" /><span className="font-semibold">YIL KAPATMA / AKTARMA</span></div>
        <p className="text-sm text-slate-400">Seçtiğiniz yılın tüm müşterilerini yeni yıla kopyalar (yeni yıl boş başlar, eski yıl aynen kalır).</p>
        <div className="flex flex-wrap items-end gap-2">
          <div><label className="text-xs text-slate-500">KAYNAK YIL</label><Input data-testid="copy-from" type="number" value={yr.from_year} onChange={(e) => setYr((y) => ({ ...y, from_year: e.target.value }))} className="h-10 w-28 border-slate-700 bg-slate-800 text-slate-100" /></div>
          <ArrowRightLeft className="mb-2 h-4 w-4 text-slate-500" />
          <div><label className="text-xs text-slate-500">HEDEF YIL</label><Input data-testid="copy-to" type="number" value={yr.to_year} onChange={(e) => setYr((y) => ({ ...y, to_year: e.target.value }))} className="h-10 w-28 border-slate-700 bg-slate-800 text-slate-100" /></div>
          <Button data-testid="copy-year" onClick={copyYear} className="h-10 bg-emerald-600 text-white hover:bg-emerald-700"><ArrowRightLeft className="mr-1 h-4 w-4" /> AKTAR</Button>
        </div>
      </div>
    </div>
  );
}

function PermissionsManager() {
  const [perms, setPerms] = useState(null);
  const [sections, setSections] = useState([]);
  const SEC_LABELS = {
    dashboard: "GÖSTERGE PANELİ", musteriler: "MÜŞTERİLER", mukerrer: "MÜKERRER FİRMALAR",
    "hizli-ekle": "HIZLI FİRMA EKLE", raporlar: "RAPORLAR", harita: "MÜŞTERİ HARİTASI",
    "kargo-girisi": "KARGO GİRİŞİ", kargolar: "GÖNDERİLEN KARGOLAR", "kargo-alimi": "KARGO ALIMI",
    "tir-rota": "TIR ROTA", hesaplama: "HESAPLAMA", teklifler: "TEKLİFLER", sozlesmeler: "SÖZLEŞMELER",
    tedarikci: "TEDARİKÇİ", muhasebe: "MUHASEBE", "is-listesi": "İŞ LİSTESİ", whatsapp: "WHATSAPP MESAJ", ayarlar: "AYARLAR",
  };
  const ACTIONS = [
    ["can_export", "EXCEL İNDİR (PIN'li)"], ["can_import", "EXCEL YÜKLE"],
    ["can_delete", "KAYIT SİL (tek/seçili)"], ["can_request_delete", "TÜMÜNÜ SİL TALEBİ"], ["manage_users", "KULLANICI YÖNET"],
  ];
  useEffect(() => {
    api.get("/permissions").then((r) => { setPerms(r.data.permissions); setSections(r.data.sections); }).catch((e) => toast.error(e.response?.data?.detail || "ÖNCE FİRMA SEÇİN"));
  }, []);
  const toggleSec = (role, sec) => setPerms((p) => {
    const cur = new Set(p[role].sections || []);
    cur.has(sec) ? cur.delete(sec) : cur.add(sec);
    return { ...p, [role]: { ...p[role], sections: [...cur] } };
  });
  const PAGES = NAV.filter((n) => !n.super);
  const togglePage = (role, n, on) => setPerms((p) => {
    const hp = new Set(p[role].hidden_pages || []);
    const secs = new Set(p[role].sections || []);
    if (on) hp.add(n.to); else { hp.delete(n.to); if (n.sec) secs.add(n.sec); }
    return { ...p, [role]: { ...p[role], hidden_pages: [...hp], sections: [...secs] } };
  });
  const toggleAct = (role, act) => setPerms((p) => ({ ...p, [role]: { ...p[role], [act]: !p[role][act] } }));
  const save = async () => { await api.put("/permissions", { permissions: perms }); toast.success("YETKİLER KAYDEDİLDİ"); };
  if (!perms) return <div className="rounded-xl border border-amber-500/30 bg-amber-500/10 px-6 py-10 text-center text-amber-200">ÖNCE ÜST BARDAN BİR FİRMA SEÇİN.</div>;
  const Role = ({ role, title, color }) => (
    <div className="rounded-lg border border-slate-800 bg-slate-900 p-4">
      <div className={`mb-3 font-head text-sm font-bold ${color}`}>{title}</div>
      <div className="mb-2 text-xs font-semibold uppercase text-slate-500">GÖREBİLECEĞİ SAYFALAR (MENÜYE EKLENEN HER YENİ SAYFA BURADA OTOMATİK ÇIKAR)</div>
      <div className="flex flex-wrap gap-1.5">
        {PAGES.map((n) => {
          const on = (!n.sec || (perms[role].sections || []).includes(n.sec)) && !(perms[role].hidden_pages || []).includes(n.to);
          return <button key={n.to} data-testid={`perm-${role}-page-${n.to.replace(/[^a-z0-9]/gi, "") || "home"}`} onClick={() => togglePage(role, n, on)} className={`rounded-full px-2.5 py-1 text-xs font-semibold ${on ? "bg-blue-500/20 text-blue-300 ring-1 ring-blue-500/40" : "bg-slate-800 text-slate-500 line-through"}`}>{n.label}</button>;
        })}
      </div>
      <div className="mb-2 mt-4 text-xs font-semibold uppercase text-slate-500">ÖZEL İŞLEMLER</div>
      <div className="flex flex-wrap gap-2">
        {ACTIONS.map(([a, l]) => (
          <label key={a} className="flex cursor-pointer items-center gap-2 rounded-lg border border-slate-700 px-2.5 py-1.5 text-xs text-slate-300">
            <Switch data-testid={`perm-${role}-${a}`} checked={!!perms[role][a]} onCheckedChange={() => toggleAct(role, a)} />{l}
          </label>
        ))}
      </div>
    </div>
  );
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <p className="text-sm text-slate-400">SEÇİLİ FİRMADA <b>YÖNETİCİ</b> VE <b>KULLANICI</b> ROLLERİNİN NELERE ERİŞEBİLECEĞİNİ SİZ BELİRLERSİNİZ.</p>
        <Button data-testid="save-perms" onClick={save} className="bg-blue-600 text-white hover:bg-blue-700"><Save className="mr-1 h-4 w-4" /> KAYDET</Button>
      </div>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <Role role="admin" title="FİRMA YÖNETİCİSİ (ADMIN)" color="text-amber-300" />
        <Role role="user" title="KULLANICI" color="text-sky-300" />
      </div>
    </div>
  );
}

function WhatsAppTemplatesManager() {
  const { isSuperAdmin } = useAuth();
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ baslik: "", metin: "", scope: isSuperAdmin ? "global" : "tenant" });
  const load = () => api.get("/wa/templates").then((r) => setItems(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);
  const add = async () => {
    if (!form.baslik.trim() || !form.metin.trim()) { toast.error("BAŞLIK VE METİN GEREKLİ"); return; }
    try { await api.post("/wa/templates", form); toast.success("ŞABLON EKLENDİ"); setForm({ baslik: "", metin: "", scope: isSuperAdmin ? "global" : "tenant" }); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "HATA"); }
  };
  const del = async (id) => { try { await api.delete(`/wa/templates/${id}`); load(); } catch (e) { toast.error(e.response?.data?.detail || "HATA"); } };
  return (
    <div className="max-w-3xl space-y-4">
      <div className="rounded-lg border border-slate-800 bg-slate-900 p-4 text-sm text-slate-400">
        Cari listesindeki WhatsApp butonuna basınca bu başlıklar çıkar. Mesajda <code className="text-emerald-300">{"{firma}"}</code> ve <code className="text-emerald-300">{"{yetkili}"}</code> otomatik doldurulur.
        {isSuperAdmin ? " GENEL şablonlar tüm firmalarda görünür (★)." : " Eklediğiniz şablonlar yalnız firmanızda görünür."}
      </div>
      <div className="rounded-lg border border-slate-800 bg-slate-900 p-4 space-y-3">
        <div className="grid gap-2 sm:grid-cols-[180px_1fr]">
          <Input data-testid="wa-tpl-baslik" placeholder="BAŞLIK (örn. RANDEVU)" value={form.baslik} onChange={(e) => setForm((f) => ({ ...f, baslik: trUpper(e.target.value) }))} className="h-10 border-slate-700 bg-slate-800 text-slate-100" />
          <textarea data-testid="wa-tpl-metin" rows={2} placeholder="Sayın {yetkili}, {firma} ..." value={form.metin} onChange={(e) => setForm((f) => ({ ...f, metin: e.target.value }))} className="rounded-md border border-slate-700 bg-slate-800 p-2 text-sm text-slate-100" />
        </div>
        <div className="flex items-center justify-between">
          {isSuperAdmin ? (
            <select value={form.scope} onChange={(e) => setForm((f) => ({ ...f, scope: e.target.value }))} className="h-9 rounded-md border border-slate-700 bg-slate-800 px-2 text-sm text-slate-100">
              <option value="global">GENEL (TÜM FİRMALAR)</option><option value="tenant">SADECE SEÇİLİ FİRMA</option>
            </select>
          ) : <span className="text-xs text-slate-500">Firma şablonu</span>}
          <Button data-testid="wa-tpl-add" onClick={add} className="bg-blue-600 text-white hover:bg-blue-700"><Plus className="mr-1 h-4 w-4" /> ŞABLON EKLE</Button>
        </div>
      </div>
      <div className="space-y-2">
        {items.length === 0 && <div className="py-6 text-center text-sm text-slate-500">ŞABLON YOK</div>}
        {items.map((t) => (
          <div key={t.id} className="flex items-start justify-between gap-3 rounded-lg border border-slate-800 bg-slate-900 p-3">
            <div className="min-w-0">
              <div className="flex items-center gap-2 font-semibold text-slate-200">{t.baslik}{t.tenant_id === null && <span className="rounded-full bg-amber-500/20 px-2 py-0.5 text-[10px] text-amber-300">GENEL ★</span>}</div>
              <div className="mt-1 whitespace-pre-wrap text-xs text-slate-400">{t.metin}</div>
            </div>
            {(t.tenant_id !== null || isSuperAdmin) && (
              <button data-testid={`wa-tpl-del-${t.baslik}`} onClick={() => del(t.id)} className="rounded-md p-1.5 text-slate-400 hover:bg-slate-700 hover:text-rose-400"><Trash2 className="h-4 w-4" /></button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default function Settings() {
  const { isSuperAdmin, isAdmin, selectedTenant } = useAuth();
  const [tab, setTabRaw] = useState(() => localStorage.getItem("mwcrm_settings_tab") || "columns");
  const setTab = (k) => { setTabRaw(k); localStorage.setItem("mwcrm_settings_tab", k); };
  const TABS = [
    { k: "columns", l: "KOLONLAR", icon: Columns3 },
    { k: "menu", l: "MENÜ", icon: MenuIcon },
    { k: "users", l: "KULLANICILAR", icon: UsersIcon },
    ...(isSuperAdmin ? [{ k: "perms", l: "YETKİLER", icon: ShieldCheck }] : []),
    { k: "rowsize", l: "SATIR", icon: ScrollText },
    { k: "atf", l: "ATF ZİMMET", icon: ScrollText },
    ...(isAdmin ? [{ k: "brand", l: "LOGO", icon: ScrollText }, { k: "payment", l: "ÖDEME", icon: KeyRound }] : []),
    { k: "whatsapp", l: "WHATSAPP", icon: MessageCircle },
    { k: "security", l: "GÜVENLİK", icon: KeyRound },
    { k: "integrations", l: "ENTEGRASYON", icon: Plug },
    { k: "audit", l: "KAYITLAR", icon: ScrollText },
    ...(isAdmin ? [{ k: "copylog", l: "AKTARMA", icon: ScrollText }] : []),
    ...(isSuperAdmin ? [{ k: "releases", l: "SÜRÜMLER", icon: ScrollText }, { k: "ai", l: "YAPAY ZEKA", icon: KeyRound }] : []),
  ];
  if (isSuperAdmin && !selectedTenant) {
    return (
      <div className="mw-fade-up">
        <h1 className="font-head text-3xl font-bold tracking-tight text-white">AYARLAR</h1>
        <div className="mt-6 rounded-xl border border-amber-500/30 bg-amber-500/10 px-6 py-10 text-center text-amber-200" data-testid="select-firm-notice">
          ÖNCE ÜST BARDAN BİR FİRMA SEÇİN. AYARLAR SEÇİLİ FİRMAYA AİTTİR.
        </div>
      </div>
    );
  }
  return (
    <div className="mw-fade-up flex h-[calc(100vh-90px)] flex-col gap-3">
      <div data-testid="settings-tabbar" className="flex shrink-0 items-center gap-1 overflow-x-auto whitespace-nowrap rounded-xl border border-slate-800 bg-slate-900 p-1">
        <h1 className="mr-2 shrink-0 px-2 font-head text-lg font-bold tracking-tight text-white">AYARLAR</h1>
        {TABS.map((t) => {
          const Icon = t.icon;
          return (
            <button key={t.k} data-testid={`settings-tab-${t.k}`} onClick={() => setTab(t.k)} className={`flex shrink-0 items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-bold ${tab === t.k ? "bg-blue-600 text-white" : "text-slate-400 hover:bg-slate-800 hover:text-slate-200"}`}>
              <Icon className="h-3.5 w-3.5" /> {t.l}
            </button>
          );
        })}
      </div>
      <div data-testid="settings-content" className="min-h-0 flex-1 overflow-y-auto pr-1">
      {tab === "columns" && <ColumnsManager />}
      {tab === "menu" && <MenuSettings />}
      {tab === "rowsize" && <RowSizeSettings />}
      {tab === "atf" && <AtfSettings />}
      {tab === "releases" && isSuperAdmin && <ReleasesSettings />}
      {tab === "ai" && isSuperAdmin && <AiSettings />}
      {tab === "brand" && <BrandSettings />}
      {tab === "payment" && <PaymentSettings />}
      {tab === "users" && <UsersManager />}
      {tab === "perms" && <PermissionsManager />}
      {tab === "whatsapp" && <WhatsAppTemplatesManager />}
      {tab === "security" && <SecurityManager />}
      {tab === "security" && isAdmin && !isSuperAdmin && (
        <div data-testid="settings-delete-all" className="mt-4 max-w-lg rounded-lg border border-rose-900/60 bg-rose-950/20 p-4">
          <div className="mb-1 text-sm font-bold text-rose-300">TÜM MÜŞTERİLERİ SİL</div>
          <p className="mb-3 text-xs text-slate-400">FİRMA PIN İLE ÇALIŞIR. KAYITLAR ÇÖP KUTUSUNA ALINIR, NİHAİ SİLME ANA ADMİN ONAYIYLA YAPILIR.</p>
          <DeleteAllCustomers trigger={(start) => <Button data-testid="delete-all-button" onClick={start} className="bg-rose-700 text-white hover:bg-rose-800">TÜMÜNÜ SİL (ÇÖP KUTUSU)</Button>} />
        </div>
      )}
      {tab === "integrations" && <><ParasutSettings /><div className="h-3" /><IntegrationsManager /></>}
      {tab === "audit" && <AuditManager />}
      {tab === "copylog" && <CopyLog />}
      {!TABS.some((t) => t.k === tab) && <ColumnsManager />}
      </div>
    </div>
  );
}

export { ColumnsManager, UsersManager, SecurityManager, AuditManager, IntegrationsManager, PermissionsManager, WhatsAppTemplatesManager };
